import './ProcessingStep.css';
export default function ProcessingStep({ isExecuting = false }) {
  return (
    <div className="vd-processing">
      <div className="vd-processing__spinner" />
      <p className="vd-processing__label">
        {isExecuting
          ? 'Executing your actions...'
          : 'Analyzing your brain dump...'}
      </p>

      {/* Skeleton loading cards */}
      {!isExecuting && (
        <div className="vd-skeleton">
          <div className="vd-skeleton__card" />
          <div className="vd-skeleton__card" />
          <div className="vd-skeleton__card" />
        </div>
      )}
    </div>
  );
}
